import { Component, OnInit, Injector } from '@angular/core';
import { MobileBasePage } from 'src/app/core/base/mobile-base-page';
import { NavParams } from '@ionic/angular';

@Component({
  selector: 'app-service-choice',
  templateUrl: './service-choice.component.html',
  styleUrls: ['./service-choice.component.scss'],
})
export class ServiceChoiceComponent extends MobileBasePage implements OnInit {

  inputs: any;
  isImplementFocus = true;
  constructor(private injector: Injector, public navParams: NavParams) {
    super(injector);
    this.inputs = this.navParams.get('inputs');
    console.log('ServiceChoiceComponent constructor()', this.inputs);
  }

  ngOnInit() {}

  focus(ev){
    if (!this.isImplementFocus) return;
    this.isImplementFocus = false;
    let checked = ev.target.checked || '';
    console.log('focus() -> ev:', ev, checked);
    if (!checked){
      this.presentAlert();
    }else{
      this.presentCancel(ev);
    }
    this.isImplementFocus = true;
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      // header: 'Alert',
      // subHeader: 'Subtitle',
      message: 'Our staff will serve you as soon as possible.',
      backdropDismiss: false,
      buttons: [{
        text: 'Ok',
        handler: () => {
          console.log('Confirm Okay', this.inputs);
          // todo callapi to offer service with staff

        }
      }]
    });

    await alert.present();
  }

  async presentCancel(ev) {
    const alert = await this.alertController.create({
      // header: 'Cancel',
      // subHeader: 'Subtitle',
      message: 'Cancel request.',
      backdropDismiss: false,
      buttons: [{
        text: 'No',
        handler: () => {
          console.log('Confirm No', this.inputs);
          ev.target.click();
        }
      }, {
        text: 'Yes',
        handler: () => {
          console.log('Confirm Yes', this.inputs);
          // todo callApi to stop servcie

        }
      }]
    });

    await alert.present();
  }

}
